/**
 * Requires a JSON file stored in the project's src/data folder
 * 
 * @memberof core.helpers
 * @param {string} filePath The relative file path (from the projects src/data folder) 
 *  of the json file to load.
 * @returns The required file.
 */
function getPreloadedJson(filePath) {
  let path = filePath.replace(new RegExp('.json$'), '').replace(new RegExp('^./data/'), ''),
    json = require('../../../src/data/' + path + '.json');
  return json;
}

export default getPreloadedJson;



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/getPreloadedJson.js